import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronDown, FiMoreHorizontal } from 'react-icons/fi';
import { CardAvatarStack } from '@/components/ui/card-avatar-stack';
import { Dropdown } from '@/components/custom/dropdown/dropdown';
import { useSession } from '@/hooks/useSession';
import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import moment from 'moment';
import usePermission from '@/hooks/usePermission';
import { confirm } from '@/lib/confirm';
import { useTranslation } from 'react-i18next';
import { i18n } from '@/lib/i18n/i18n';

export default function ClassroomCard(props) {
  const { t } = useTranslation();
  const { classroom, editClassroomForm, participants, deleteClassroom } = props;

  return (
    <div className="card">
      <div className="card__header">
        <div className="card__inner-header">
          <h3
            className="card__title"
            title={classroom?.title}
          >
            {classroom?.title}
          </h3>
        </div>

        <p className="expanded-calendar__tag expanded-calendar__tag--course">{classroom?.course?.title}</p>
      </div>

      <div className="card__body">
        <div className="card__columns">
          <p className="card__info">
            <span>{t('textsCommon.availableUntil')}:</span> {moment(classroom && classroom['end-date']).format(t('datesForm.formatDate'))}
          </p>
        </div>

        <div className="card__columns">
          <div className="card__avatar">
            <h4 className="card__avatar-title">{t('projects.participants')}</h4>
            {(participants || []).length > 0 && (
              <CardAvatarStack
                data={participants}
                modalTitle={`Participantes da Turma ${classroom.title}`}
              />
            )}
          </div>
        </div>
      </div>

      <div className="card__footer">
        <div
          className="btn-group btn-group--with-dropdown"
          role="group"
          aria-label="Ações"
        >
          {usePermission('Gerenciar turmas', 'Turmas') && (
            <Link
              to={`/classrooms/${classroom.id}/gerenciar`}
              type="button"
              className="btn btn--outline btn--small"
            >
              {t('sideBar.participants')}
            </Link>
          )}

          {usePermission('Editar turmas', 'Turmas') || usePermission('Excluir turmas', 'Turmas') ? (
            <Dropdown className="btn--small btn btn--outline">
              <Dropdown.Toggle>
                <FiChevronDown />
              </Dropdown.Toggle>

              <Dropdown.Content>
                {usePermission('Editar turmas', 'Turmas') && <Dropdown.Item onClick={() => editClassroomForm(classroom)}>{t('button.edit')}</Dropdown.Item>}
                {usePermission('Excluir turmas', 'Turmas') && (
                  <Dropdown.Item
                    onClick={async () => {
                      const confirmed = await confirm({
                        title: t('projects.warningDeleteClass'),
                        description: t('projects.warningDeleteCannotBeUndoneText'),
                        confirmText: t('button.yes'),
                        cancelText: t('button.no')
                      });
                      if (confirmed) {
                        deleteClassroom(classroom);
                      }
                    }}
                  >
                    {t('button.delete')}
                  </Dropdown.Item>
                )}
              </Dropdown.Content>
            </Dropdown>
          ) : null}
        </div>
      </div>
    </div>
  );
}
